<template>
  <div class="payment-selection-container">
    <div class="header-actions">
      <el-button round icon="el-icon-back" @click="$emit('back', 'method')">返回</el-button>
    </div>

    <div class="content-wrapper">
      <div class="total-amount">
        訂單總計 <span class="highlight">NT$ {{ paymentInfo.total || 0 }}</span>
      </div>

      <el-row :gutter="20" type="flex" justify="center" class="m-b-24">
        <el-col v-if="paymentInfo.paymentMethods.includes('StoreCredit')" :xs="24" :sm="10" :md="10">
          <div class="payment-card" @click="handleSelect('StoreCredit')">
            <div class="icon-circle">
              <svg class="fillFull" height="42.869" viewBox="0 0 57.262 42.869" width="57.262" xmlns="http://www.w3.org/2000/svg">
                <g fill="#ea6a2a" stroke="#fff" transform="translate(-7.25 -11.5)">
                  <path
                    d="m14.728 53.869h34.891a6.978 6.978 0 0 0 6.981-6.978h.436a6.978 6.978 0 0 0 6.978-6.978v-20.935a6.978 6.978 0 0 0 -6.981-6.978h-34.89a6.978 6.978 0 0 0 -6.978 6.978h-.436a6.978 6.978 0 0 0 -6.979 6.978v20.935a6.978 6.978 0 0 0 6.978 6.978zm38.38-20.935h-41.869v-3.489h41.869zm-30.965-17.445h34.89a3.489 3.489 0 0 1 3.489 3.489v20.935a3.489 3.489 0 0 1 -3.489 3.487h-.433v-17.444a6.978 6.978 0 0 0 -6.978-6.978h-30.969a3.489 3.489 0 0 1 3.49-3.489zm-7.414 6.978h34.89a3.489 3.489 0 0 1 3.489 3.489h-41.869a3.489 3.489 0 0 1 3.489-3.489zm38.38 13.956v10.468a3.489 3.489 0 0 1 -3.489 3.489h-34.892a3.489 3.489 0 0 1 -3.489-3.489v-10.467z"
                  />
                  <path d="m25.245 32.489h10.467a1.745 1.745 0 0 0 0-3.489h-10.467a1.745 1.745 0 0 0 0 3.489z" transform="translate(11.727 12.657)" />
                </g>
              </svg>
            </div>
            <h3 class="card-title">現場信用卡</h3>
          </div>
        </el-col>
        <el-col v-if="paymentInfo.paymentMethods.includes('Atm')" :xs="24" :sm="10" :md="10">
          <div class="payment-card" @click="handleSelect('Atm')">
            <div class="icon-circle">
              <svg class="fillFull" height="52" viewBox="0 0 52 52" width="52" xmlns="http://www.w3.org/2000/svg">
                <path d="m1 1h50v50h-50z" fill="none" stroke="#ea6a2a" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <g fill="#ea6a2a" stroke="#fff">
                  <path
                    d="m120.81 115.852a1.153 1.153 0 0 1 .042-.234l3.961-13c.235-.746 1.194-1.108 2.173-1.108s1.94.362 2.175 1.108l3.985 13a1.15 1.15 0 0 1 .042.234c0 .79-1.214 1.366-2.131 1.366-.533 0-.956-.171-1.093-.619l-.724-2.664h-4.489l-.724 2.664c-.128.448-.555.619-1.093.619-.91-.001-2.124-.576-2.124-1.366zm7.736-4.475-1.556-5.711-1.556 5.711z"
                    transform="translate(-113.158 -95.657)"
                  />
                  <path
                    d="m213.707 102.45c.7 0 1 .766 1 1.47 0 .81-.363 1.514-1 1.514h-2.94v11.572c0 .683-.832 1.023-1.662 1.023s-1.663-.34-1.663-1.023v-11.573h-2.942c-.639 0-1-.7-1-1.514 0-.7.3-1.47 1-1.47z"
                    transform="translate(-184.553 -96.469)"
                  />
                  <path
                    d="m302.731 112.508a1.221 1.221 0 0 1 -1.108.619 1.093 1.093 0 0 1 -1.044-.619l-2.025-3.707v8.2c0 .683-.832 1.023-1.662 1.023s-1.662-.34-1.662-1.023v-12.889a1.538 1.538 0 0 1 1.662-1.662c1.193 0 1.7.127 2.578 1.662l2.2 3.836 2.2-3.836c.874-1.535 1.385-1.662 2.579-1.662a1.529 1.529 0 0 1 1.663 1.662v12.893c0 .683-.832 1.023-1.663 1.023s-1.662-.34-1.662-1.023v-7.991z"
                    transform="translate(-263.752 -96.469)"
                  />
                </g>
                <path d="m6.944 30.372h19.124" fill="none" stroke="#ea6a2a" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <path
                  d="m139.6 281h12.977v11.01a1.557 1.557 0 0 1 -1.557 1.557h-9.867a1.557 1.557 0 0 1 -1.557-1.557v-11.01z"
                  fill="none"
                  stroke="#ea6a2a"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  transform="translate(-129.382 -250.628)"
                />
              </svg>
            </div>
            <h3 class="card-title">線下匯款</h3>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" type="flex" justify="center" class="m-b-24">
        <el-col v-if="paymentInfo.paymentMethods.includes('Cash')" :xs="24" :sm="10" :md="10">
          <div class="payment-card" @click="handleSelect('Cash')">
            <div class="icon-circle">
              <svg class="strokeFull" height="50" viewBox="0 0 50 50" width="50" xmlns="http://www.w3.org/2000/svg">
                <g fill="none">
                  <g stroke="#e86a35" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2">
                    <ellipse cx="35" cy="6" rx="14" ry="5" />
                    <path d="m21 7v6c0 2.761 6.266 5 14 5s14-2.239 14-5v-6" />
                    <path d="m28.55 24.439a35.748 35.748 0 0 0 6.45.561c7.734 0 14-2.239 14-5v-6" />
                    <path d="m21 14v4.27" />
                    <path d="m29.025 31.523a36.2 36.2 0 0 0 5.975.477c7.734 0 14-2.238 14-5v-6" />
                    <path d="m28.948 38.51a36.136 36.136 0 0 0 6.052.49c7.734 0 14-2.238 14-5v-6" />
                    <ellipse cx="15" cy="23" rx="14" ry="5" />
                    <path d="m1 24v6c0 2.762 6.266 5 14 5s14-2.238 14-5v-6" />
                    <path d="m1 31v6c0 2.762 6.266 5 14 5s14-2.238 14-5v-6" />
                    <path d="m1 38v6c0 2.762 6.266 5 14 5s14-2.238 14-5v-6" />
                  </g>
                </g>
              </svg>
            </div>
            <h3 class="card-title">現金付款</h3>
          </div>
        </el-col>
        <el-col :xs="24" :sm="10" :md="10">
          <div class="payment-card disabled">
            <div class="icon-circle">
              <BaseIcon name="question" />
            </div>
            <h3 class="card-title">不指定付款方式</h3>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" type="flex" justify="center">
        <el-col v-if="!paymentInfo.paymentMethods.includes('StoreLinePay')" :xs="24" :sm="20" :md="10">
          <div class="payment-card wide" @click="handleSelect('StoreLinePay')">
            <div class="icon-circle line-border">
              <img src="@assets/images/icons/line-pay.png" alt="Line Pay" />
            </div>
            <h3 class="card-title">LINE Pay</h3>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step3OfflineType',
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleSelect(val) {
      this.$emit('next', { key: 'type', value: val })
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-selection-container {
  padding: 20px;
  background-color: #fcfcfc;
  min-height: 80vh;

  .total-amount {
    text-align: center;
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 40px;
    .highlight {
      color: #ea6a2a;
      font-weight: bold;
      margin-left: 10px;
    }
  }

  .m-b-24 {
    margin-bottom: 24px;
  }

  .payment-card {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 45px 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover(.disabled) {
      border-color: #ea6a2a;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.7;
      background-color: #fafafa;
    }

    &.wide {
      padding: 30px 20px;
    }

    .icon-circle {
      width: 100px;
      height: 100px;
      border: 1.5px solid #ea6a2a;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 44px;
      color: #ea6a2a;
      margin-bottom: 20px;
      overflow: hidden;

      &.line-border {
        border-color: #ea6a2a; // 圖片中 Line Pay 好像是用灰框或無框
      }
    }

    .card-title {
      font-size: 1.1rem;
      color: #444;
      margin: 0;
      font-weight: 500;
    }
  }
}
</style>
